import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CryptoHelperService {
  // Encode request payload into Base64 format
  encodePayload(body: any): { data: string } {
    const json = JSON.stringify(body);
    const encoded = btoa(unescape(encodeURIComponent(json))); // Supports Unicode characters
    // // console.log("encoded request", json);
    return { data: encoded };
  }

  // Decode Base64 response payload back to original object
  decodePayload(body: any): any {
    try {
      if (body && typeof body.data === "string") {
        const decoded = decodeURIComponent(escape(atob(body.data)));
        // // console.log("decoded response", decoded);
        return JSON.parse(decoded);
      }

      // Return original response if payload format is unexpected
      return body;
    } catch (e) {
      // Prevent app crash if decoding fails
      console.error("[CryptoHelper] Failed to decode response payload:", e);
      return body;
    }
  }
}
